define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-brand-solution-type';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {
                retailCategoryActive: ''
            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeContentPartnershipHeaderMenuId, 'animate__faster animate__fadeIn', 'brand-solution-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeRetailCollaborationHeaderMenuId, 'animate__faster animate__fadeIn', 'brand-solution-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeExperentialMarketingHeaderMenuId, 'animate__faster animate__fadeIn', 'brand-solution-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeContentPartnershipAnimMainId, 'animate__faster animate__slideInLeft', 'brand-solution-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeContentPartnershipAnimBoxId, 'animate__faster animate__slideInRight', 'brand-solution-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeRetailCollaborationAnimMainId, 'animate__faster animate__slideInLeft', 'brand-solution-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeRetailCollaborationAnimBoxId, 'animate__faster animate__slideInRight', 'brand-solution-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeExperentialMarketingAnimMainId, 'animate__faster animate__slideInLeft', 'brand-solution-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionTypeExperentialMarketingAnimBoxId, 'animate__faster animate__slideInRight', 'brand-solution-type', {});

                const windowWidth = $(window).width();

                if(windowWidth > 599) {
                    preloader.setPreloadBulk('module-brand-solution-type-retail-box-2560', view.publicVars.preloadRetailBoxTab2560);
                }

                if(windowWidth <= 599) {
                    preloader.setPreloadBulk('module-brand-solution-type-retail-box-599', view.publicVars.preloadRetailBoxTab599);
                }

            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleBrandSolutionTypeRetailContentCategoryCls).click(function () {
                    const type = container.getData($(this)[0], 'type');

                    view.methods.handleCategoryRetailBoxClick(type, this);
                });
            };

            view.methods = {
                handleCategoryRetailBoxClick: function (type, handler) {

                    $(view.publicVars.cssId.moduleBrandSolutionTypeRetailContentCategoryCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                    if(type === view.privateVars.retailCategoryActive) {
                        type = '';
                        view.privateVars.retailCategoryActive = '';
                    } else {
                        $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                        view.privateVars.retailCategoryActive = type;
                    }

                    if(type === 'product-licensing') {
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationProductLicensingBoxInnerId).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationPromotionLicensingBoxInnerId).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else if(type === 'promotion-licensing') {
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationProductLicensingBoxInnerId).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationPromotionLicensingBoxInnerId).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else {
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationProductLicensingBoxInnerId).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $(view.publicVars.cssId.moduleBrandSolutionTypeRetailCollaborationPromotionLicensingBoxInnerId).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
